import { useSessionTree } from '@services/session'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = SelectProps & {
  parentId?: number
}

export const ParkingLotAutoCompleteSelect = (props: Props) => {
  const { t } = useTranslation()

  const { parentId, ...others } = props

  const { byId, loading } = useSessionTree()

  return (
    <Select
      loading={loading}
      showSearch
      filterOption={(input, option) => {
        return (
          typeof option?.children === 'string' &&
          (option.children as string).includes(input)
        )
      }}
      {...others}>
      {!!parentId
        ? byId[parentId]?.children.map((x: any) => (
            <Select.Option key={x.id} value={x.id}>
              {x.name}
            </Select.Option>
          ))
        : null}
    </Select>
  )
}

export default ParkingLotAutoCompleteSelect
